import { getNomeSobrenome } from './getNomeSobrenome';

const piePalette = { 'Baixa-1': '#348ECA', 'Media-2': '#2D5269', 'Alta-3': '#00ABA4' };

function getDadosGraficosUnidade(relatorio) {
  const dadosComportamentos = [];

  relatorio.participantes.forEach((p) => {
    dadosComportamentos.push({
      y: p.relatorioComportamentos.total,
      gosto: p.relatorioComportamentos.gosto,
      naoGosto: p.relatorioComportamentos.naoGosto,
      ideal: p.relatorioComportamentos.ideal,
      participante: getNomeSobrenome(p.nome),
    });
  });

  return {
    comportamento: {
      bar: {
        dados: [{
          name: 'Servidor',
          data: dadosComportamentos.sort((a, b) => {
            if (a.y < b.y) { return 1; }
            if (a.y > b.y) { return -1; }
            return 0;
          }),
          color: '#2D5269',
        }],
        categorias: dadosComportamentos.map((d) => d.participante),
      },
      pie: {
        series: [{
          name: 'Categorias',
          data: [
            { name: 'Gosto', y: relatorio.comportamentos.gosto },
            { name: 'Não Gosto', y: relatorio.comportamentos.naoGosto },
            { name: 'Ideal Seria', y: relatorio.comportamentos.ideal },
          ],
        }],
        subSeries: [],
      },
    },
    responsabilidade: {
      pie: {
        series: [{
          name: 'Impactos',
          data: [
            {
              name: 'Impacto 1',
              y: relatorio.responsabilidadesConsolidadas.impactoUm,
              color: piePalette['Baixa-1'],
            },
            {
              name: 'Impacto 2',
              y: relatorio.responsabilidadesConsolidadas.impactoDois,
              color: piePalette['Media-2'],
            },
            {
              name: 'Impacto 3',
              y: relatorio.responsabilidadesConsolidadas.impactoTres,
              color: piePalette['Alta-3'],
            },
          ].sort((a, b) => {
            if (a.y > b.y) {
              return -1;
            }
            if (a.y < b.y) {
              return 1;
            }
            return 0;
          }),
        }],
        subSeries: [],
      },
      pie2: {
        series: [{
          name: 'Dificuldades',
          data: [
            {
              name: 'Dificuldade 1',
              y: relatorio.responsabilidadesConsolidadas.dificuldadeUm,
              color: piePalette['Baixa-1'],
            },
            {
              name: 'Dificuldade 2',
              y: relatorio.responsabilidadesConsolidadas.dificuldadeDois,
              color: piePalette['Media-2'],
            },
            {
              name: 'Dificuldade 3',
              y: relatorio.responsabilidadesConsolidadas.dificuldadeTres,
              color: piePalette['Alta-3'],
            },
          ].sort((a, b) => {
            if (a.y > b.y) {
              return -1;
            }
            if (a.y < b.y) {
              return 1;
            }
            return 0;
          }),
        }],
        subSeries: [],
      },
      pie3: {
        series: [{
          name: 'Complexidades',
          data: [
            {
              name: 'Complexidade Alta',
              y: relatorio.responsabilidadesConsolidadas.complexidadeAlta,
              color: piePalette['Alta-3'],
            },
            {
              name: 'Complexidade Média',
              y: relatorio.responsabilidadesConsolidadas.complexidadeMedia,
              color: piePalette['Media-2'],
            },
            {
              name: 'Complexidade Baixa',
              y: relatorio.responsabilidadesConsolidadas.complexidadeBaixa,
              color: piePalette['Baixa-1'],
            },
          ].sort((a, b) => {
            if (a.y > b.y) {
              return -1;
            }
            if (a.y < b.y) {
              return 1;
            }
            return 0;
          }),
        }],
        subSeries: [],
      },
    },
    competenciaTecnica: {
      bar: {
        categorias: [
          'Competências Cadastradas',
          'Competências Validadas',
          'Competências Consolidadas',
        ],
        dados: [{
          name: 'Quantidade',
          data: [
            relatorio.competenciasTecnicas.total,
            relatorio.competenciasTecnicasValidadas.total,
            relatorio.competenciasTecnicasConsolidadas.total,
          ],
          color: '#2D5269',
        }],
      },
      pie: {
        series: [{
          name: 'Competências',
          data: relatorio.competenciasTecnicas.competenciasTecnicas
            .map((c) => ({ name: c.nome, y: c.total })),
        }],
        subSeries: [],
      },
    },
    loaded: true,
  };
}

export default getDadosGraficosUnidade;
